import html2canvas from 'html2canvas';

export const div2ImgDataURL = async (divId: string) => {
  const div = document.getElementById(divId);
  if (!div) return;

  const dataURL: any = await getLauncherPreviewImgDataURL(div);
  const blob = await (await fetch(dataURL)).blob();

  return blob;
};

const divToImg = (div: HTMLElement) =>
  new Promise((resolve) => {
    html2canvas(div, {
      backgroundColor: null,
      useCORS: true,
      allowTaint: false,
      scale: 0.5,
    }).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      resolve(imgData);
    });
  });

const getLauncherPreviewImgDataURL = async (div: HTMLElement) => {
  const imgDataURL = await divToImg(div);

  return imgDataURL;
};
